<div class="row">
    <div class="col-xs-12">
        <div class="main-box">
            <div class="main-box-body clearfix" style="padding:20px">
                <div *ngIf="busOfClient?.length > 0" class="col-xs-12">
                    <div class="row">
                        <div class="col-sm-1">BUs:</div>
                    </div>
                    <div class="row">
                        <div class="col-xs-8" style="margin-left:45px">
                            <div class="col-xs-4" *ngFor="let bu of busOfClient" style="margin:10px 0px 10px 0px">
                                <span *ngIf="bu.userPermissibility"
                                      class="fa fa-phone-square emerald pointer"
                                      style="font-size: 1.2em;height: 1em;line-height: 1.7em;"
                                      [popover]="contactDetailsPopoverTpl"
                                      [popoverContext]="{ bu: bu }"
                                      popoverTitle="Contact Details"
                                      placement="auto"
                                      containerClass="contact-details-popover"
                                      triggers="mouseenter">
                                </span>
                                <span *ngIf="!bu.userPermissibility"
                                      tooltip="Contact Details"
                                      class="fa fa-phone-square"
                                      style="font-size: 1.2em; color:darkgrey">
                                </span>
                                <span [ngClass]="{'disable-element-view': !bu.userPermissibility}">{{bu.buName}}</span>
                            </div>
                        </div>
                        <div class="col-xs-2"></div>
                    </div>
                </div>
                <div *ngIf="!(busOfClient?.length > 0)" class="col-xs-12">
                    No BUs Available.
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #contactDetailsPopoverTpl let-bu="bu">
    <div>
        <div class="row" *ngIf="bu.buContactList?.length > 0">
            <table class="table">
                <thead>
                    <tr>
                        <th>Full Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let contact of bu.buContactList" style="font-size: 12px;">
                        <td>
                            <span>{{contact.firstName}} &nbsp;</span>
                            <span *ngIf="contact.lastName !== null"> {{contact.lastName}}</span>
                        </td>
                        <td>
                            <span *ngIf="contact.workPhone != null">{{contact.workPhone}}&nbsp;(w)</span><br>
                            <span *ngIf="contact.workPhone != null">{{contact.mobilePhone}}&nbsp;(m)</span>
                        </td>
                        <td>
                            {{contact.email}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row" *ngIf="!(bu.buContactList?.length > 0)">
            <div class="col-xs-12 text-center">
                No Contact Details Available!
            </div>
        </div>
    </div>
</ng-template>
